import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

const ViewIssueModal = ({ isOpen, onClose, issue }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 p-2 flex items-center bg-black/50 backdrop-blur-sm justify-center bg-opacity-50">
      <div className="bg-white  p-6  h-[26rem] w-full md:min-w-md lg:h-fit overflow-y-auto lg:min-w-lg lg:max-w-4xl  rounded-lg shadow-lg relative">
        {/* Close Button */}
        <AiFillCloseCircle
          onClick={onClose}
          className="cursor-pointer text-primaryColor absolute top-4 right-4"
          size={30}
        />

        {/* Modal Title */}
        <h2 className="text-lg font-bold text-primaryTextColor mb-6 text-center">
          View Issue Details
        </h2>

        {/* Content */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-500 ">
              Issue Title:
            </span>
            <span className="text-sm text-primaryTextColor">
              {issue?.issueTitle || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-500 ">
              Building Name:
            </span>
            <span className="text-sm text-primaryTextColor">
              {issue?.buildingName?.nameBuilding || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-500 ">Date:</span>
            <span className="text-sm text-primaryTextColor">
              {issue?.createdAt?.slice(0, 10) || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-500 ">
              Status:
            </span>
            <span
              className={`text-sm font-semibold py-1 px-3 w-fit rounded-md ${
                issue?.issueStatus === "In Progress"
                  ? "bg-yellow-100 text-yellow-600"
                  : issue?.issueStatus === "Resolved"
                  ? "bg-green-100 text-green-600"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {issue?.issueStatus || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm text-gray-500 ">
              Last Updated:
            </span>
            <span className="text-sm text-primaryTextColor">
              {issue.resolvedDate?.slice(0, 10) || "N/A"}
            </span>
          </div>

          <div className="flex flex-col">
            <span className="font-semibold text-sm ttext-gray-500 ">
              Reported By:
            </span>
            <span className="text-sm text-primaryTextColor">
              {issue?.user || "Admin"}
            </span>
          </div>

          {/* Full-width Description */}
          <div className="flex flex-col md:col-span-2">
            <span className="font-semibold text-sm text-gray-500 ">
              Description:
            </span>
            <p className="text-sm text-primaryTextColor leading-relaxed">
              {issue?.issueDescription || "No Description Provided."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewIssueModal;
